import BirlExercise from 'models/birl/exercise'
import getModelCollection from 'braindamage/api/getModelCollection'
import { useQuery } from '@tanstack/react-query'

export default ({ query, path = "/api/birl/exercises" } = {}) => {
  return useQuery({
    queryKey: ['birl_exercises', path, query],
    queryFn: async () => {
      const data = await getModelCollection(path, BirlExercise, query)
      return data
    },
    onError: async (data) => {
      console.log("useBirlExerciseCollectionQuery Error:", data)
    }
  })
}
